//import template from './schema-epure-simple.html'
//import template from './schema-epure-complete.html'
import template from './schema-epure-container.html'
import css from './schema-epure.css'
import { SchemaEpureController } from './schema-epure.controller.js'

export const SchemaEpureComponent = {
  template: template,
  templateNamespace:'svg',
  controller: SchemaEpureController,
  controllerAs: 'SchemaEpureController',
  bindings: {
    //clickMouvement: '='
  },
  require: {
    parentSimulator: '^^simulatorComponent'
  },
  bindings:{
  	svgcontent:'='
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/schema-epure/schema-epure.component.js